import ListLayout from "../../../components/layout/main/ListLayout";
import { PageCard } from "../../../styles/CommonStyles";
import FilterLayout from "../../../components/layout/filter/FilterLayout";
import { useState } from "react";
import { CacheKeys, swapsListOptions } from "../../../core/constants/filter";
import { useWindowSize } from "../../../core/hooks/common/useWindowSize";
import { TABLET_SIZE } from "../../../core/constants/common";
import { useAclContext } from "../../../core/contexts/acl";
import SwapListingTable from "../../../components/main/reports/swap/SwapListingTable";
import RSwapListingTable from "../../../components/responsive/main/reports/swap/RSwapListingTable";
import { useGetAllSwaps } from "../../../core/services/react-query/report/swap";


const SwapListing = () => {

    const { width } = useWindowSize()
    const [swaps, setSwaps] = useState({ data: null, loading: true })

    const { permissions } = useAclContext()
    const hasDownload = permissions?.export?.write
    console.log(swaps);

    const onQuerySuccess = (res) => {
        setSwaps(res)
    }

    const Component = width > TABLET_SIZE ? SwapListingTable : RSwapListingTable

    return (
        <ListLayout>
            <PageCard>
                <FilterLayout
                    query={useGetAllSwaps}
                    onQuerySuccess={onQuerySuccess}
                    options={swapsListOptions}
                    cache={CacheKeys.SWAPS}
                    hasDownload={hasDownload}
                >
                    {width &&
                        <Component
                            data={swaps}
                        />
                    }
                </FilterLayout>
            </PageCard>
        </ListLayout>
    )
}

export default SwapListing;
